import { useConfig } from "@/contexts/ConfigContext"

import { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent } from "@/components/ui/card"
import { MagicCard } from "@/components/ui/magic-card"
import { BorderBeam } from "@/components/ui/border-beam"

export const MagicContainerHeader = CardHeader
export const MagicContainerFooter = CardFooter
export const MagicContainerTitle = CardTitle
export const MagicContainerDescription = CardDescription
export const MagicContainerContent = CardContent

export function MagicContainer({ children, className, showBeam = false }) {
    const { theme } = useConfig()

    return (
        <MagicCard
            gradientColor={theme === "dark" ? "#EA580C" : "#E2E2E2"}
            gradientOpacity={theme === "dark" ? 0.15 : 0.4}
            className={className}
        >
            {showBeam && (
                <BorderBeam size={250} duration={12} delay={9} colorFrom="#EA580C" colorTo="#fb923c" border_radius={12} />
            )}
            {children}
        </MagicCard>
    )
}
